// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FTaS","content":"styles_content__1OxZM"};